import { ArrowRightToLine } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowRightToLineIcon = createLucideIcon(ArrowRightToLine);
